module.exports = __webpack_public_path__ + "img/pzzx.7590fd87.svg";